import { ESdChangeReason, IWorkFlow } from "@kuika/kuika-cl-model";
import { withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";

export interface IWorkFlowSubprocessPropertiesState {}

export interface IWorkFlowSubprocessPropertiesProps {
  selectedNodeId: string | undefined;
}

class WorkFlowSubprocessProperties extends PureSdComponent<
  IWorkFlowSubprocessPropertiesProps,
  IWorkFlowSubprocessPropertiesState
> {
  constructor(props) {
    super(props);
  }

  render() {
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;

    if (wf) {
      return (
        <div className="kuika__workflow__properties">
          <div className="kuika_workflow-properties__section">
            You may see the detail of subprocess by expanding the subprocess. Use blue arrow to expand the subprocess.
          </div>
        </div>
      );
    }
    return <></>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.SaveWorkflow ||
      changeReason === ESdChangeReason.ClickWfDesignXmlNode ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const workflowSubprocessProperties = withContext<IWorkFlowSubprocessPropertiesProps>(
  withSD<IWorkFlowSubprocessPropertiesProps>(WorkFlowSubprocessProperties)
);
export { workflowSubprocessProperties as WorkflowSubprocessProperties };
